export enum UrineLevelType {
  URINE_ABSENT = 'URINE_ABSENT',
  URINE_LITTLE = 'URINE_LITTLE',
  URINE_MEDIUM = 'URINE_MEDIUM',
  URINE_MUCH = 'URINE_MUCH',
  URINE_FULL = 'URINE_FULL'
}

// This will be deprecated in favor of the localized version
export const UrineLevelLabels: { [key in UrineLevelType]: string } = {
  [UrineLevelType.URINE_ABSENT]: 'Trocken',
  [UrineLevelType.URINE_LITTLE]: 'Wenig',
  [UrineLevelType.URINE_MEDIUM]: 'Mittel',
  [UrineLevelType.URINE_MUCH]: 'Viel',
  [UrineLevelType.URINE_FULL]: 'Voll'
};

export const UrineLevelColors: { [key in UrineLevelType]: string } = {
  [UrineLevelType.URINE_ABSENT]: '#D9D9D9',
  [UrineLevelType.URINE_LITTLE]: '#72C889',
  [UrineLevelType.URINE_MEDIUM]: '#F0D355',
  [UrineLevelType.URINE_MUCH]: '#E6994E',
  [UrineLevelType.URINE_FULL]: '#E85A47'
};

// Helper function to get translated urine level labels using i18n
export const getLocalizedUrineLevelLabel = (
  type: UrineLevelType, 
  t: (key: string) => string
): string => {
  if (!type) {
    console.error('Missing type parameter in getLocalizedUrineLevelLabel:', type);
    return 'Unknown';
  }
  
  const translationKeys: { [key in UrineLevelType]: string } = {
    [UrineLevelType.URINE_ABSENT]: 'urineLevel.absent',
    [UrineLevelType.URINE_LITTLE]: 'urineLevel.little',
    [UrineLevelType.URINE_MEDIUM]: 'urineLevel.medium',
    [UrineLevelType.URINE_MUCH]: 'urineLevel.much',
    [UrineLevelType.URINE_FULL]: 'urineLevel.full'
  };
  
  const key = translationKeys[type as UrineLevelType];
  if (!key) {
    console.error('Invalid type in getLocalizedUrineLevelLabel:', type);
    // Fallback to original label if available, otherwise return the type
    return UrineLevelLabels[type as UrineLevelType] || String(type);
  }
  
  return t(key);
}; 